import { isTauriSync } from "./tauri";

// Lokale toast-notificaties (vanuit de socket-handler, niet vanuit een
// Web Push). In Tauri-mode gebruiken we de native plugin; in PWA-mode
// de Web Notification API met dezelfde signature.

let tauriPermissionPromise: Promise<boolean> | null = null;

async function ensureTauriPermission(): Promise<boolean> {
  if (tauriPermissionPromise) return tauriPermissionPromise;
  tauriPermissionPromise = (async () => {
    try {
      const { isPermissionGranted, requestPermission } = await import(
        "@tauri-apps/plugin-notification"
      );
      let granted = await isPermissionGranted();
      if (!granted) {
        const res = await requestPermission();
        granted = res === "granted";
      }
      return granted;
    } catch {
      return false;
    }
  })();
  return tauriPermissionPromise;
}

export async function notify(title: string, body: string): Promise<void> {
  if (isTauriSync()) {
    try {
      const ok = await ensureTauriPermission();
      if (!ok) return;
      const { sendNotification } = await import("@tauri-apps/plugin-notification");
      await sendNotification({ title, body });
    } catch {
      /* */
    }
    return;
  }
  // PWA-mode: Web Notification API. Permissie is via 'n explicit knop in
  // StatusBar gevraagd; hier alleen tonen als al granted.
  if (typeof window === "undefined") return;
  if (!("Notification" in window)) return;
  if (Notification.permission !== "granted") return;
  try {
    new Notification(title, { body, icon: "/icons/192.png" });
  } catch {
    /* */
  }
}

/** Vraagt de Web Notification-permissie expliciet aan (vanaf een
 *  user-gesture, niet automatisch). Retourneert true bij granted. */
export async function requestWebNotificationPermission(): Promise<boolean> {
  if (typeof window === "undefined" || !("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  try {
    const res = await Notification.requestPermission();
    return res === "granted";
  } catch {
    return false;
  }
}
